// import React from 'react';
// import { Outlet } from 'react-router-dom';
// import PublicHeader from './PublicHeader';

// const PublicLayout = () => {
//   return (
//     <div className="flex flex-col min-h-screen">
//       <PublicHeader />
//       <main className="flex-grow">
        
//         <Outlet />
//       </main>
    
//     </div>
//   );
// };

// export default PublicLayout;
// web view 





import React from 'react';
import { Outlet } from 'react-router-dom';
import PublicHeader from './PublicHeader';

const PublicLayout = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <PublicHeader />
      {/* We use a simple container. The CSS above handles the gap. */}
      <main className="flex-grow">
        <Outlet />
      </main>
    </div>
  );
};

export default PublicLayout;
//mobile view 